/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CInput,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CRow
} from '@coreui/react'
import { colors } from '../../utils/General'
import CIcon from '@coreui/icons-react'
import _ from "lodash";
//auth
import { } from '../../core/authentication'
import { useDispatch, useSelector } from "react-redux";
import actions from '../../core/redux/action'
import {faLock, faUser} from "@fortawesome/free-solid-svg-icons";
import bg_image from '../../assets/background/login_bg.jpg';

const Login = () => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const dispatch = useDispatch();
  const authRes = useSelector((state) => state.auth)
  const status = _.get(authRes, 'status')
  const login = () => {
    dispatch(actions.getLogin({ username, password }))
  }

  return (
    <div className="c-app c-default-layout flex-row align-items-center"  
      style={{ backgroundImage: `url(${bg_image})`, height: '100vh', backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat', backgroundSize: 'cover', 
      }}>
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md="4">
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <h1>Joonaak</h1>
                  <p className="text-muted">Sign in to your account</p>
                  {(_.get(status, 'message')) && (
                    <div className="small text-muted"><span className="text-danger">{_.get(status, 'message')}</span></div>
                  )}

                  <CInputGroup className="mb-3">
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <FontAwesomeIcon icon={faUser} />
                      </CInputGroupText>
                    </CInputGroupPrepend>
                    <CInput type="text" placeholder="Username" autoComplete="username" onChange={even => setUsername(even.target.value)} />
                  </CInputGroup>
                  <CInputGroup className="mb-4">
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <FontAwesomeIcon icon={faLock} />
                      </CInputGroupText>
                    </CInputGroupPrepend>
                    <CInput type="password" placeholder="Password" autoComplete="current-password" onChange={even => setPassword(even.target.value)} />
                  </CInputGroup>
                  <CRow>
                    <CCol xs="6">
                      <CButton
                        onClick={login}
                        disabled={(_.get(authRes, 'isLoading'))} style={{ backgroundColor: colors.status.primary }}
                        className="px-4">
                        <strong className="text-white">Login</strong>
                      </CButton>
                    </CCol>
                  </CRow>
                </CCardBody>
              </CCard>
              {/* <CCard className="text-white py-5 d-md-down-none" style={{ width: '44%', backgroundColor: colors.status.primary }}>
                <CCardBody className="text-center">
                  <div>
                    <p>
                      At Joonaak, we aim to offer last-mile connectivity between people and businesses while continually integrate technology and develop effective solutions of superior quality and value to help your business grow and expand.</p>
                  </div>
                </CCardBody>
              </CCard> */}
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default Login
